import { PropsWithChildren, ReactElement, useContext } from "react";
import classNames from "classnames";
import { UniqueInputIdContext } from "../../Contexts/UniqueInputIdContext";
import styles from "./FormLabel.module.less";

export type FormLabelProps = {
	isRequired?: boolean;
	isEllipsed?: boolean;
	tooltip?: string;
};

export const FormLabel = (props: PropsWithChildren<FormLabelProps>): ReactElement => {
	const {
		isRequired,
		isEllipsed,
		tooltip,
		children
	} = props;

	const { id } = useContext(UniqueInputIdContext);

	return (
		<label
			className={classNames(
				styles.root,
				{
					[styles.root_required]: isRequired,
					[styles.root_isEllipsed]: isEllipsed
				}
			)}
			htmlFor={id}
			title={tooltip}
		>
			{children}
		</label>
	);
};
FormLabel.displayName = "FormLabel";